import { getPaymentSubscriptions, updateSubscriptionDate } from '../services/napi';
import {
  PAYMENT_SUBSCRIPTION_FETCH_SUCCESS,
  PAYMENT_SUBSCRIPTION_UPDATE_SUCCESS
} from '../constant/actionType';

export function fetchPaymentSubscriptions() {
  return async (dispatch, getState) => {
    try {
      const { _id: projectId } = getState().project.currentProject;
      const response = await getPaymentSubscriptions(projectId);
      dispatch({
        data: response.data.subscriptions,
        type: PAYMENT_SUBSCRIPTION_FETCH_SUCCESS
      });
    } catch (error) {
      console.error(error);
    }
  };
}

export function updatePaymentSubscription(subscriptionId, body, onSuccess, notify) {
  return async (dispatch, getState) => {
    try {
      const { _id: projectId } = getState().project.currentProject;
      const response = await updateSubscriptionDate(projectId, subscriptionId, body);
      if (response.data.success) {
        dispatch({
          data: false,
          type: PAYMENT_SUBSCRIPTION_UPDATE_SUCCESS
        });

        notify('Next Payment Date Successfully Updated', 'success');
      } else {
        notify('Failed Next Payment Date Update', 'warning');
      }
      if (onSuccess) {
        onSuccess();
      }
    } catch (error) {
      console.error(error);
      dispatch({
        data: false,
        type: PAYMENT_SUBSCRIPTION_UPDATE_SUCCESS
      });

      notify('Failed Next Payment Date Update', 'warning');
    }
  };
}

export function subscriptionUpdateSuccess(boolean) {
  return async (dispatch) => {
    dispatch({
      data: boolean,
      type: PAYMENT_SUBSCRIPTION_UPDATE_SUCCESS
    });
  };
}
